module.exports = __webpack_public_path__ + "img/tgh.00450b63.jpg";